<template>
  <header class="c-header">
    <div class="c-header__logo">
      <a href="/"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 363.34 78.96" width="363.34" height="78.96"><title>P.I.C.S</title><path class="a" d="M113.22,0H101.69a1.15,1.15,0,0,0-1.09,1.5L113.08,40,100.94,77.41a1.14,1.14,0,0,0,1.08,1.5h11.5a1.14,1.14,0,0,0,1.09-.8L126.8,40,114.31.8a1.14,1.14,0,0,0-1.09-.8"/><path class="a" d="M362.05,75.79A2.66,2.66,0,0,1,359.52,78h-8.77a1.87,1.87,0,0,1-1.89-2.19l1.26-8.69a2.65,2.65,0,0,1,2.53-2.19h8.78a1.86,1.86,0,0,1,1.89,2.19Z"/><path class="a" d="M259.35,75.79A2.64,2.64,0,0,1,256.82,78h-8.76a1.87,1.87,0,0,1-1.9-2.19l1.27-8.69A2.63,2.63,0,0,1,250,64.91h8.77a1.85,1.85,0,0,1,1.89,2.19Z"/><path class="a" d="M155.53,75.79A2.66,2.66,0,0,1,153,78h-8.76a1.87,1.87,0,0,1-1.9-2.19l1.27-8.69a2.63,2.63,0,0,1,2.53-2.19h8.77a1.85,1.85,0,0,1,1.89,2.19Z"/><path class="a" d="M74.87,75.79A2.66,2.66,0,0,1,72.34,78H63.57a1.87,1.87,0,0,1-1.89-2.19l1.26-8.69a2.65,2.65,0,0,1,2.53-2.19h8.78a1.86,1.86,0,0,1,1.89,2.19Z"/><path class="a" d="M39.91.1H14.62a1.36,1.36,0,0,0-1.29,1.09L0,77.79a.89.89,0,0,0,.91,1.09H12.57a1.34,1.34,0,0,0,1.28-1.07l5.62-32.47a1.38,1.38,0,0,1,1.28-1.06H32.21c2.59,0,11.36-.51,17.91-6.66s8-11.57,8.58-18.24C59.63,8.36,53.11.1,39.91.1M34.49,31.63H23a.88.88,0,0,1-.9-1.07L25,13.82a1.35,1.35,0,0,1,1.28-1.08H37.79A7,7,0,0,1,45,19.38a12.3,12.3,0,0,1-4.47,10.19,9.8,9.8,0,0,1-6,2.06"/><path class="a" d="M205.1,66.19h-6a7.21,7.21,0,0,1-6.67-8.71l6.43-35.65c.9-5,5.38-9,10-9h6a7.09,7.09,0,0,1,7.43,6.92,1.13,1.13,0,0,0,1.12,1.1h11.85a1.14,1.14,0,0,0,1.12-1C237.85,8.87,229.27,0,218,0h-8.41c-11.4,0-22.4,9.19-24.43,20.41l-6.91,37.87C176.24,69.66,184,79,195.58,79h9.27c11,0,21.81-8.67,24.27-19.56a1.12,1.12,0,0,0-1.1-1.35H216.27a1.12,1.12,0,0,0-1.05.72c-1.35,3.52-4.71,7.42-10.12,7.42"/><path class="a" d="M282.28,58.12l11.69,0a1.16,1.16,0,0,1,1.13.93c0,.11,0,.19,0,.22,1,5.49,3.3,7.22,9.34,7.22h1.91c6.18,0,10.68-3.87,11.59-8.54,1-5.19-2.82-7.94-4.76-9l-7.31-3.88c-10.79-5.68-17.22-10.92-14.76-24.42C293.31,8.78,304.64.07,316.12.07h4.18c11.53,0,19.85,9.44,18.28,19.59a2.28,2.28,0,0,1,0,.24,1.14,1.14,0,0,1-1.14,1H325.56a1.15,1.15,0,0,1-1.15-1.12c0-.05,0-.08,0-.09-.36-4.3-3.23-6.72-7.55-6.87-6.67-.16-10.85,4.15-11.75,8.48s1.79,6.44,4.09,7.62l12.48,6.63c10.32,5.56,11.92,15.09,9.86,24.23-1.92,10.07-12.5,19.19-25.34,19.19h-5.77c-8.29.08-14.81-3-17.34-9.72a30.73,30.73,0,0,1-2-9.89v0a1.17,1.17,0,0,1,1.16-1.19"/></svg></a>
    </div>
    <div class="c-header__tool" :class="{'isHide': isFirst && isTop, 'isShow1': isShow1}">
      <div class="c-header__trigger" @click="openGnav" :class="{'isCover': isShowRelatedSp()}">
        <div class="c-header__triggerWrap">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div class="c-header__bc">
        <ul>
          <li><a href="/">TOP</a></li>
          <li v-for="(val, name) in bread"><a :href="val">{{name}}</a></li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
  import { breakpoint, assets_path } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';

  export default {
    props: ['bread'],
    data() {
      return {
        assets_path: assets_path,
        isFirst: false,
        isShow1: false
      }
    },
    store,
    computed: {
      isShowRelatedSp: function () {
        return function() {
          return (this.$store.getters.isShowRelatedSp && !this.$store.getters.isMobile);
        }
      }
    },
    created() {
      // 初回サイトアクセスとTOPページを判定
      this.$store.commit('setFirst');
      this.$store.commit('setTop');
      this.isFirst = this.$store.getters.getFirst;
      this.isTop = this.$store.getters.getTop;
    },
    mounted() {
    },
    methods: {
      openGnav() {
        this.$store.commit('setShowGnav', true);
      },
      showUI() {
        this.isShow1 = true;
      }
    }
  }
</script>
